import React, { Component } from 'react';
import { Layout } from 'antd';
const { Footer } = Layout;

import './app-footer.less';

class AppFooter extends Component {
  render() {
    return (
      <Footer className="app-footer">
        <span className="copyright">
          Copyright © 2021 BI WORLDWIDE{ ' ' }
          <span className={ 'hide-for-moobile' }>® All Rights Reserved.</span>
        </span>
      </Footer>
    );
  }
}

export default AppFooter;
